import { render, staticRenderFns } from "./simplifyOwnerAccessContol.vue?vue&type=template&id=ef96a7ca&scoped=true"
import script from "./simplifyOwnerAccessContol.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerAccessContol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef96a7ca",
  null
  
)

export default component.exports